import { RangeInput } from '@cp/ds/src/components/form/components/field/range';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Field } from '@youhelp-ru/ui';
import React from 'react';
import type { FieldPath } from 'react-hook-form';
import { useController, useFormContext } from 'react-hook-form';
import type { FormModel } from '../model/form';

type FilterRangeFieldProps = {
  name: string;
  min: number;
  max: number;
  format: (value: number) => React.ReactNode;
  step?: number;
  disabled?: boolean;
};

export const FilterRangeField = ({ name, min, max, format, step, disabled = false }: FilterRangeFieldProps) => {
  const theme = useTheme();
  const { control } = useFormContext<FormModel>();
  const { field } = useController({ name: name as FieldPath<FormModel>, control });

  const value = (field.value ?? [min, max]) as [number, number];

  return (
    <Field sx={{ width: 1, minWidth: 0, alignItems: 'stretch' }}>
      <RangeInput
        disabled={disabled}
        max={max}
        min={min}
        onChange={field.onChange}
        rangeSliderStyle
        renderValueItem={(v, { index }) => (
          <Typography component="span" variant="body bold">
            {index === 0 ? (
              <>
                {'от '}
                {format(v)}
              </>
            ) : (
              <>
                {'до '}
                {format(v)}
              </>
            )}
          </Typography>
        )}
        step={step}
        sx={{ color: theme.palette['brand gray'] }}
        value={value}
      />
    </Field>
  );
};
